import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { FiCheck } from "react-icons/fi";

const CustomDropdown = ({ 
  label, 
  options, 
  selected, 
  onChange, 
  colors,
  isMobile = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const dropdownRef = useRef();

  const handleSelect = (value) => {
    onChange(value);
    setIsOpen(false);
   
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div 
      className="relative w-full lg:w-auto" 
      ref={dropdownRef}
      data-testid={`dropdown-${isMobile ? "mobile" : "desktop"}`}
    >
      {/* Label - Hidden on mobile, shown on larger screens */}
      <label className="text-[14px] sm:text-[16px] mb-[8px] sm:mb-[10px] text-[#666] sm:text-[#8D8D8D] leading-[100%] font-semibold font-public-sans hidden sm:block">
        {label}
      </label>

      {/* Dropdown Button */}
      <button
        type="button"
        onClick={() => {
          setIsOpen((prev) => !prev);
          
        }}
       className="w-full bg-[#1E1E1E] text-[#8D8D8D] text-xs sm:text-sm lg:text-sm font-medium leading-[100%] rounded-[5px] px-2 sm:px-3 lg:px-4 py-[6px] sm:py-[8px] lg:py-[10px] h-[36px] sm:h-[38px] lg:h-[40px] flex justify-between items-center outline-none  transition-all duration-300"
      >
        <div className="flex items-center gap-1.5 sm:gap-2">
          {colors && (
            <span
              className="w-[8px] h-[8px] sm:w-[10px] sm:h-[10px] lg:w-[12px] lg:h-[12px] rounded-full"
              style={{ backgroundColor: colors[selected] || "#BDBDBD" }}
            />
          )}
          <span className="truncate">{selected}</span>
        </div>
        <IoIosArrowDown
          className={`text-white ml-1.5 sm:ml-2 transition-transform duration-300 w-[14px] h-[14px] sm:w-[16px] sm:h-[16px] lg:w-[18px] lg:h-[18px] opacity-60 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown Options */}
      {isOpen && (
        <ul className="absolute z-20 mt-1 w-full bg-[#1E1E1E] max-h-[200px] sm:max-h-64 [@media(min-width:1460px)]:max-h-56 overflow-y-auto">
          {options.map((option) => (
            <li
              key={option}
              onClick={() => handleSelect(option)}
              className={`px-2 sm:px-3 lg:px-4 py-[6px] sm:py-[8px] lg:py-[10px] text-xs sm:text-sm lg:text-sm cursor-pointer flex items-center justify-between transition-all duration-300 hover:text-white ${
                selected === option
                  ? "text-white font-semibold"
                  : "text-gray-500"
              }`}
            >
              <div className="flex items-center gap-1.5 sm:gap-2">
                {colors && (
                  <span
                    className="w-[8px] h-[8px] sm:w-[10px] sm:h-[10px] lg:w-[12px] lg:h-[12px] rounded-full"
                    style={{ backgroundColor: colors[option] || "#BDBDBD" }}
                  />
                )}
                <span className="truncate">{option}</span>
              </div>
              {selected === option && (
                <FiCheck className="text-cyan-400 w-[14px] h-[14px] sm:w-[16px] sm:h-[16px] lg:w-[18px] lg:h-[18px] ml-1.5 sm:ml-2 flex-shrink-0" />
              )}
            </li>
          ))}
        </ul>
      )}

      {/* Spacer for larger screens */}
      <div className="h-4 sm:h-6 [@media(min-width:1460px)]:block hidden"></div>
    </div>
  );
};

export default CustomDropdown;